var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"unstuck-home"},[_c('div',{staticClass:"unstuck-title"},[_vm._v("Unstuck")]),_c('div',{staticClass:"unstuck-content"},[_c('div',{staticClass:"unstuck-content-title"},[_vm._v("Unstuck")]),_c('div',{staticClass:"unstuck-content-text"},[_vm._v("Unstuck史蒂夫说的")])])])
}]

export { render, staticRenderFns }